import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const T3: Site = {
  id: 't3',
  logo: 'svg/t3.svg',
  favicon: 'svg/t3-favicon.svg',
  label: 'T3',
  analyticsName: 't3',
  hostname: 't3.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
